<!--
 * @Author: 曹捷
 * @Date: 2021-10-27 14:55:00
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-11 15:42:21
 * @Description: 
 子应用主体
 判断子应用  是否有 三级目录 已经目录定位
-->
<template>
  <a-layout class="app-main h100" v-show="!routeMate.mainApp">
    <a-layout-header :style="{height:'46px'}" v-if="!routeMate.mainApp &&hasMenu">
      <bodyTabMenuVue></bodyTabMenuVue>
    </a-layout-header>
    <a-layout-content>
      <div id="subapp-viewport" class="h100"></div>
    </a-layout-content>
  </a-layout>
</template>
<script>
import { computed, watch, onMounted, reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import bodyTabMenuVue from '@/layout/components/bodyTabMenu.vue'
import MenuHook from './../../hook/menu'
import { useStore } from 'vuex'
export default {
  components: { bodyTabMenuVue },
  setup () {
    let route = useRoute(), store = useStore()
    let menuHook = MenuHook()
    let _data = reactive({
      hasMenu: false
    })
    let _computed = {
      routeMate: computed(() => route.meta)
    }
    let methos = {
      hasMenu () {
        let list = menuHook.getRouteList(store, route)
        _data.hasMenu = list.length >= 2
      }
    }
    onMounted(() => {
      methos.hasMenu()
    })
    watch(() => route.path, (path) => {
      methos.hasMenu()
      // 判断 路由没找到 重定向的过程中  由于路由无法匹配 面包屑查找会丢失，需要再页面渲染完成，重新判断路径是否重定向
      // 前后地址如果是重定向 pathname 不同 则重新计算面包屑  
      let pathname = window.location.pathname
      setTimeout(() => {
        if (pathname !== window.location.pathname) {
          methos.hasMenu()
        }
      }, 0)
    })
    return {
      ...toRefs(_data),
      ..._computed
    }
  }
}
</script>

<style lang="less">
#subapp-viewport {
  > div {
    height: 100%;
  }
}
</style>